
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkhed() {



    const cardData =
    {
        keyword: 'Cab Service in Khed',
        heading: 'Platinum24 Cabs: Cab Service in Khed',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Khed, catering to local travel, business commutes, airport transfers, and outstation journeys. Our diverse fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride for solo travelers, families, and corporate groups. With professional chauffeurs, timely pickups, and transparent pricing, we make every journey stress-free and reliable. Whether it’s a quick city drop or a long-distance trip from Khed to Pune, Mumbai, Nashik, or other destinations, Platinum24 Cabs guarantees comfort, affordability, and a pleasant travel experience.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


      "services": [
    {
      "name": "Khed Cab Service",
      "description": "Travel comfortably and safely with our Khed Cab Service, designed for everyday commuters, tourists, and business travelers. Our fleet of clean, well-maintained vehicles ensures smooth rides across Khed and surrounding areas. Whether you're heading to work, visiting friends, or exploring the town, we offer quick pickups, professional drivers, and 24/7 availability. Enjoy air-conditioned comfort, sanitized cars, and punctual service that fits your schedule. Book easily via phone or online and experience convenience on your terms."
    },
    {
      "name": "Taxi Service Khed",
      "description": "Our Taxi Service in Khed is your go-to option for reliable and efficient transportation. We provide city and outstation rides with flexible booking durations, professional drivers, and a wide selection of cars to choose from. Whether it’s a quick local drop, a meeting, or a family outing, our taxis ensure a safe and timely journey. Backed by real-time tracking and responsive customer support, this service is perfect for those who value comfort, speed, and transparency."
    },
    {
      "name": "Khed Local Taxi",
      "description": "Need a quick and affordable ride across town? Our Khed Local Taxi service offers door-to-door transport within the city at highly competitive prices. Ideal for running errands, visiting friends, shopping, or attending appointments, our taxis are driven by experienced locals who know the area well. With clean interiors, comfortable seating, and real-time GPS, your everyday travel becomes smoother and more convenient than ever."
    },
    {
      "name": "Affordable Taxi Khed",
      "description": "Budget-friendly yet reliable — our Affordable Taxi Khed service is perfect for cost-conscious travelers. Whether you're a student, daily commuter, or local resident, we offer the best prices on all city and outstation routes without compromising on safety or service. No surge pricing, no hidden fees — just honest rates, clean vehicles, and professional drivers. Choose from hourly, daily, or custom ride packages to fit your needs."
    },
    {
      "name": "Khed Taxi with Driver",
      "description": "Sit back and relax with our Khed Taxi with Driver service, ideal for passengers who prefer chauffeur-driven convenience. All our drivers are background-verified, courteous, and well-versed with Khed's roads and traffic patterns. Whether you're attending a business meeting, going sightseeing, or need full-day transportation, we ensure smooth, secure, and comfortable rides. Enjoy privacy, punctuality, and peace of mind every time you book with us."
    },
    {
      "name": "Khed Airport Taxi",
      "description": "Ensure timely airport transfers with our Khed Airport Taxi service, providing drop-offs and pickups to and from Pune Airport and other regional hubs. Our drivers track flight timings in real-time to handle delays or early landings efficiently. Spacious luggage-friendly vehicles and fixed, all-inclusive fares guarantee a stress-free start or end to your journey. Whether solo or with a group, book ahead and enjoy smooth, on-time transportation."
    },
    {
      "name": "Cab Rental Khed",
      "description": "Our Cab Rental Khed service provides flexible, on-demand transportation for every occasion. Choose from a wide variety of vehicles — from compact hatchbacks to premium sedans — available for hourly, daily, or long-term rental. Ideal for weddings, business trips, sightseeing, or errands, our rental cabs come with or without a driver. All vehicles are sanitized regularly, serviced professionally, and available with doorstep delivery on request."
    },
    {
      "name": "Khed Outstation Taxi",
      "description": "Planning a trip outside the city? Our Khed Outstation Taxi service is perfect for comfortable and safe intercity travel. Whether you're heading to Pune, Mumbai, or any nearby destination, our expert drivers ensure smooth highway rides with proper rest stops and route planning. Choose from round-trip or one-way options with fuel-inclusive packages, no hidden fees, and emergency support available throughout your journey."
    },
    {
      "name": "Khed Corporate Taxi",
      "description": "Upgrade your business travel experience with our Khed Corporate Taxi service. From daily staff pickups to VIP client transportation, we offer reliable and professional taxi solutions for organizations of all sizes. Our corporate clients benefit from dedicated account management, monthly billing, GST invoicing, and the option to customize travel plans. Impress your team and clients with on-time, high-quality rides backed by professional service standards."
    },
    {
      "name": "Khed Taxi Deals",
      "description": "Enjoy exclusive savings with our Khed Taxi Deals. Whether it's a local ride or an outstation trip, take advantage of seasonal discounts, referral bonuses, and early booking offers. Designed to help you travel more and spend less, our deals are updated regularly and are available through both online and phone bookings. Get the same high-quality service at a better price — because value matters."
    },
    {
      "name": "Khed City Taxi",
      "description": "Move around the city with ease using our Khed City Taxi service. Whether you're commuting to work, heading to a social event, or visiting a friend, our taxis are ready when you are. With professional drivers, quick response times, and real-time tracking, your city travel becomes smoother and more reliable. Book instantly via app or phone and enjoy affordable fares with no surprise charges."
    },
    {
      "name": "Khed Family Taxi Service",
      "description": "Travel together with comfort using our Khed Family Taxi Service. Designed to meet the needs of families heading to functions, vacations, or outings, our spacious vehicles offer ample legroom and luggage space. Child seats and safety enhancements are available on request. Our drivers are friendly, patient, and experienced with family travel, making your journeys smooth and enjoyable from start to finish."
    },
    {
      "name": "Taxi Booking Online Khed",
      "description": "Book your ride in seconds with Taxi Booking Online Khed. Our user-friendly platform lets you schedule pickups, choose car types, and pay securely — all from your phone or desktop. Get instant confirmation and real-time updates on your booking. Whether you need a quick local drop or a planned outstation trip, our online booking system is fast, transparent, and available 24x7."
    },
    {
      "name": "Khed Taxi Service 24x7",
      "description": "Travel on your schedule with our Khed Taxi Service 24x7. We operate round the clock to serve early morning airport transfers, late-night emergencies, and everything in between. Our professional drivers and support team are always ready to respond quickly. With clean cars, safe rides, and guaranteed availability any time of day or night, you can count on us to be there when you need a ride the most."
    }
  ],
  "tableData": [
    ["Khed Cab Service", "Taxi Service Khed"],
    ["Khed Local Taxi", "Affordable Taxi Khed"],
    ["Khed Taxi with Driver", "Khed Airport Taxi"],
    ["Cab Rental Khed", "Khed Outstation Taxi"],
    ["Khed Corporate Taxi", "Khed Taxi Deals"],
    ["Khed City Taxi", "Khed Family Taxi Service"],
    ["Taxi Booking Online Khed", "Khed Taxi Service 24x7"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service in Khed",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and affordable cab services in Khed for local and outstation travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Need",
    "WhyChoosedescription": "Pick from hatchbacks, sedans, SUVs, and tempo travellers as per your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Cabs",
    "WhyChoosedescription": "All vehicles are cleaned and sanitized regularly to ensure your safety and hygiene during travel."
  },
  {
    "WhyChooseheading": "Professional Drivers with Local Expertise",
    "WhyChoosedescription": "Our experienced drivers are well-acquainted with Khed and nearby routes for a smooth ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive fares with no hidden charges—fuel, tolls, and driver fees included."
  },
  {
    "WhyChooseheading": "24/7 Support for Hassle-Free Bookings",
    "WhyChoosedescription": "Get round-the-clock assistance for booking, queries, or travel-related support in Khed."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Short & Long Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rentals based on your travel requirements."
  },
  {
    "WhyChooseheading": "Quick Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your cab easily through our website or app and get real-time confirmation and updates."
  }
]

















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Khed?',
        answer: 'Yes, Platinum24 Cabs provides dependable and affordable cab services in Khed for local and outstation travel.',
    },
    {
        question: 'How can I book a cab service in Khed with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer care.',
    },
    {
        question: 'What types of vehicles are available for cab service in Khed?',
        answer: 'We offer a wide selection of vehicles including hatchbacks, sedans, SUVs, and luxury cars to fit your travel needs.',
    },
    {
        question: 'Can I hire a cab in Khed for both local and long-distance trips?',
        answer: 'Yes, Platinum24 Cabs offers cab services for local travel in Khed as well as outstation and long-distance trips.',
    },
    {
        question: 'Are Platinum24 Cabs drivers familiar with routes in and around Khed?',
        answer: 'Yes, our drivers are experienced, licensed, and well-acquainted with the Khed region and surrounding areas.',
    },
    {
        question: 'Is hourly and full-day cab service available in Khed?',
        answer: 'Yes, we provide flexible hourly and full-day cab rental options in Khed based on your travel requirements.',
    },
    {
        question: 'Are the cabs in Khed sanitized and safe to travel in?',
        answer: 'Absolutely, all our vehicles are sanitized regularly and drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Is Platinum24 Cabs service in Khed available 24x7?',
        answer: 'Yes, we operate 24x7 in Khed so you can book a cab anytime, day or night.',
    },
    {
        question: 'What are the available payment methods for booking a cab in Khed?',
        answer: 'We accept multiple payment methods including cash, UPI, digital wallets, and all major cards.',
    },
    {
        question: 'Can I choose custom pickup and drop-off points within Khed?',
        answer: 'Yes, you can select your preferred pickup and drop-off points anywhere in Khed while booking.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ramesh Jagtap',
        feedback: 'Very reliable and clean cab service in Khed. Driver was courteous and professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Deepa Salunke',
        feedback: 'Had a great experience with Platinum24 Cabs in Khed. Booking was easy and the ride was smooth.',
        rating: 5,
    },
];







































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const khedCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Khed offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Khed, Pune"
  },
  "serviceType": [
    "Khed Cab Service",
    "Taxi Service Khed",
    "Khed Local Taxi",
    "Affordable Taxi Khed",
    "Khed Taxi with Driver",
    "Khed Airport Taxi",
    "Cab Rental Khed",
    "Khed Outstation Taxi",
    "Khed Corporate Taxi",
    "Khed Taxi Deals",
    "Khed City Taxi",
    "Khed Family Taxi Service",
    "Taxi Booking Online Khed",
    "Khed Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Khed | Affordable Taxi Service Khed Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Khed offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Khed Cab Service, Taxi Service Khed, Khed Local Taxi, Affordable Taxi Khed, Khed Taxi with Driver, Khed Airport Taxi, Cab Rental Khed, Khed Outstation Taxi, Khed Corporate Taxi, Khed Taxi Deals, Khed City Taxi, Khed Family Taxi Service, Taxi Booking Online Khed, Khed Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(khedCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkhed;